export enum MaintenanceModel {
  InHouse = 1,
  Contract = 2
}